import { AuthService } from 'src/app/services/auth.service';
import { timeout } from 'rxjs/operators';
import { SearchSectionService } from './../../../services/searchSection.service';
import { element } from 'protractor';
import { Component, OnInit, ChangeDetectorRef, AfterViewInit, Input, OnDestroy } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faMapMarkerAlt, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { ThemePalette } from '@angular/material/core';
import { SearchService } from 'src/app/services/search.service';
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { DropUpLocaionModel } from 'src/app/models/DropUpLocaionModel';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';
import { Subscription } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import 'moment/locale/ar';
import PlaceResult = google.maps.places.PlaceResult;
import { Location as LocationAutocomplete, Appearance, GermanAddress } from '@angular-material-extensions/google-maps-autocomplete';



declare var $: any;

@Component({
  selector: 'search-section',
  templateUrl: './search-section.component.html',
  styleUrls: ['./search-section.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class SearchSectionComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedLang: any;
  //@Input() searchModel: VehicleReservationSearchParm;
  searchModel: VehicleReservationSearchParm;
  currentLocation = { lat: 0, lng: 0 };
  faChevronDown = faChevronDown;
  searchForm: FormGroup;
  submitted = false;
  faMapMarkerAlt = faMapMarkerAlt;
  faCalendarAlt = faCalendarAlt;
  easyRent = false;
  address: PlaceResult;
  options = {
    types: []
    //componentRestrictions: {}
  };

  page = 1;
  pageSize;

  //Slide toggle
  color: ThemePalette = 'accent';
  checked = false;
  disabled = false;
  manualUpdate: boolean;
  minPickUpDate: any = new Date();
  minDropOffDate: any;
  minTime: any;

  pickUpLocationName;


  dropUpLocations: DropUpLocaionModel[];
  selectedLocation;


  gracePeriod: number = 0;
  minDroppOffTime: string;

  subscriptions: Subscription[] = [];
  customer: any;
  constructor(
    private formBuilder: FormBuilder,
    private _notifications: NotificationsService,
    protected cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private router: Router,
    private _dateFormatPipe: DateFormatPipe,
    private searchSectionService: SearchSectionService,
    private translate: TranslateService,
    private authService: AuthService,
    private _adapter: DateAdapter<any>
  ) {
  }

  ngOnInit() {


    this.subscriptions.push(this.searchService.searchModel.subscribe(res => {


      
      if (res == null) {
        this.router.navigate(['/home']);
      }
      this.searchModel = res;
      let pickUpDate = new Date();
      let dropOffDate = new Date();
      //Prepare Data
      if (res != null) {
        if (res.StartDate != null) {
          pickUpDate = new Date(res.StartDate);
        }
        if (res.EndDate != null) {
          dropOffDate = new Date(res.EndDate);
        }
      }

      //pickUpDate.setDate(pickUpDate.getDate() + 1);

      this.minDropOffDate = pickUpDate;


      this.pickUpLocationName = this.searchModel.FormatedLocation;

      let scopeMinTime;
      this.subscriptions.push(this.searchService.reservationSettingModel.subscribe(res => {
        let gracePeriod = 0;
        if (res != null) {
          gracePeriod = res.bookingGracePeriodSettings.bookingGracePeriodInHours;
        }
        //this.gracePeriod = gracePeriod;
        this.gracePeriod = 0;
        scopeMinTime = this.searchService.getFirstValidSartTime(pickUpDate, gracePeriod); //For the Jquery,

        //Get the first available time to book a car Today
        this.minTime = this.searchService.getFirstValidSartTime(dropOffDate, gracePeriod);

        this.minPickUpDate = this.searchService.getFirstValidSartDate(new Date(), this.gracePeriod);

      }))




      this.pageSize = this.searchService.pageSize;







      //Check if the search param is not null
      if (this.searchModel != null && this.searchModel.FromPopularCars == null || !this.searchModel.FromPopularCars) {

        //Get the Selected lat,lng from the previous page
        this.currentLocation.lat = this.searchModel.Latitude;
        this.currentLocation.lng = this.searchModel.Longitude;
       // this.minDropOffDate = this.minPickUpDate;
        this.searchForm = this.formBuilder.group({
          location: [this.searchModel.FormatedLocation != null ? this.searchModel.FormatedLocation : '', Validators.required],
          PickUpDate: [new Date(this.searchModel.StartDate), Validators.required],
          PickUpTime: [this.minTime, Validators.compose([Validators.required, Validators.pattern(
            new RegExp('(0[1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|([1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|(1[0-2]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))'))])],
          dropUpDate: [new Date(this.searchModel.EndDate), Validators.required],
          dropUpTime: [this.minTime, Validators.compose([Validators.required, Validators.pattern(
            new RegExp('(0[1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|([1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|(1[0-2]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))'))])],
          datepicker: [new Date(), Validators.required],
          eazyRent: [false],
          dropUpLocation: [true],
        });

      }
      else {

          //Get the Selected lat,lng from the previous page
          this.currentLocation.lat = this.searchModel.Latitude;
          this.currentLocation.lng = this.searchModel.Longitude;
        this.searchForm = this.formBuilder.group({
          location: [this.searchModel.FormatedLocation != null ? this.searchModel.FormatedLocation : '', Validators.required],
          PickUpDate: [new Date(this.searchModel.StartDate), Validators.required],
          PickUpTime: [this.minTime, Validators.compose([Validators.required, Validators.pattern(
            new RegExp('(0[1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|([1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|(1[0-2]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))'))])],
          dropUpDate: [new Date(this.searchModel.EndDate), Validators.required],
          dropUpTime: [this.minTime, Validators.compose([Validators.required, Validators.pattern(
            new RegExp('(0[1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|([1-9]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))|(1[0-2]:[0-5][0-9]((AM)|(PM)|(am)|(pm)))'))])],
          datepicker: [new Date(), Validators.required],
          eazyRent: [false],
          dropUpLocation: [true]
        });
      }


      if (this.searchModel.AgencyID != null) {


        this.searchForm.controls.location.setValue(this.searchModel.FromAgencyName);
        this.subscriptions.push(this.searchService.getDropUpLocationsByAgencyID(this.searchModel.AgencyID, 'en', true)
          .subscribe(res => {

            this.dropUpLocations = res;

            //this.dropUpLocations.unshift(pickUpLocationAsdropUp);
            this.searchService.returnLocations = res;

            if (this.searchModel.ToAgencyID != null) {
              this.selectedLocation = this.searchModel.ToAgencyID;
            }
            else {
              this.selectedLocation = this.searchModel.AgencyID;
            }
            let selectedDropOffLocation = res.filter(a => a.returnAgencyID == this.selectedLocation)[0];
            this.searchService.updateSelectedDropOffLocation(selectedDropOffLocation);

            this.searchModel.DropUpLocationAgencyId = this.selectedLocation;
          }));



        this.subscriptions.push(this.searchService.branches.subscribe(res => {
          if (res != null && res.length == 1) {
          }

        }))
      }
      else {


        this.subscriptions.push(this.searchService.getDropUpLocations('en')
          .subscribe(res => {

            this.dropUpLocations = res;

            if (this.searchModel.ToAgencyID != null) {
              this.selectedLocation = this.searchModel.ToAgencyID;
            }
            else {
              this.selectedLocation = null;
              // this.selectedLocation = this.dropUpLocations[0]?.returnAgencyID;
            }
            //this.dropUpLocations.unshift(pickUpLocationAsdropUp);

            this.searchModel.DropUpLocationAgencyId = this.selectedLocation;
          }));




      }



      //this.minDroppOffTime = this.searchService.getFirstValidDropOffTime(new Date(), this.gracePeriod); //For the Place holder in html
      this.minDroppOffTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Place holder in html
      if (res.StartTimeString != null && res.EndTimeString != null) {
        this.searchForm.controls.PickUpTime.setValue(res.StartTimeString);
        this.searchForm.controls.dropUpTime.setValue(res.EndTimeString);
      }
      else {
        this.searchForm.controls.PickUpTime.setValue(this.minDroppOffTime);
        this.searchForm.controls.dropUpTime.setValue(this.minDroppOffTime);
      }


      let currentDateMinTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Jquery,
      //let scopeMinDroppOffTime = this.searchService.getFirstValidDropOffTime(new Date(), this.gracePeriod); //For the Place holder in html
      let scopeMinDroppOffTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Place holder in html
      scopeMinTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Jquery,
      $(document).ready(function () {

        //Initilize the Time Picker for pick up and drop off
        $('#pickUpTimeSection').timepicker({ 'step': 15, 'minTime': '12:00am', 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });
        $('#dropUpTimeSection').timepicker({ 'step': 15, 'minTime': '12:00am', 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });



      });
    }));

    this.authService.loggedInCustomer.subscribe(res => {
      this.customer = res;
    })


    // This is For changing language for the calendar
    this.selectedLang = JSON.parse(localStorage.getItem("lang"));
    switch (this.selectedLang.isoCode2) {
      case "en":
        this._adapter.setLocale('en-US');
        break;
      case "ar":
        this._adapter.setLocale('ar-ly');
        break;
      default:
        this._adapter.setLocale('en-US');
        break;
    }

  }
  ngAfterViewInit() {

    //Attach onChange Event
    $('#pickUpTimeSection').on('changeTime', (e, dateText) => {


      this.searchForm.controls.PickUpTime.setValue($(e.target).val());
      //Check IF PickUp Time is greater than DropOff
      //this.validateDropOffTimeBasedOnPickUp($(e.target).val());
    });
    $('#dropUpTimeSection').on('changeTime', (e, dateText) => {

      this.searchForm.controls.dropUpTime.setValue($(e.target).val());
    });

  }
  /** Validate DropOffTime Based on PickUpTime*/
  validateDropOffTimeBasedOnPickUp(pickUpTime: string) {

    let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
    let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);

    //IF They are on the same day, then we need to check
    //If the picktime greater than DropOff
    if (pickUpDate.getDate() == dropOffDate.getDate()) {
      let dropOffTime = this.searchForm.controls.dropUpTime.value;
      let compareResult = this.searchSectionService.comparePickUpAndDropOffTime(pickUpTime, dropOffTime);
      //If PickUp Is Greater than dropOff , then we will validate dropOff
      if (compareResult == 1) {
        //$('#dropUpTime').timepicker('option', 'minTime', pickUpTime);
        this.searchForm.controls.dropUpTime.setValue(pickUpTime);
      }
    }

  }

  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  onSubmit() {

    this.submitted = true;

    ;


    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    var pickUpLocationValue = (<HTMLInputElement>document.getElementById('pickupLocation')).value;
    //PickUplocation Validation - because the libaray not working with FormControl
    if (this.ifStringIsNullOrEmpty(pickUpLocationValue) || this.currentLocation == null) {
      return;
    }


    // if (this.searchForm.controls["PickUpTime"].value > this.searchForm.controls["dropUpTime"].value && this.searchForm.controls["PickUpDate"].value == this.searchForm.controls["dropUpDate"].value) {

    //   this.translate.get('DropOffShouldbegreaterthanPickUp').subscribe(res => {
    //     this._notifications.warn("<span>" + res + "</span>", null, {
    //       timeOut: 30000,
    //       showProgressBar: false,
    //       pauseOnHover: true,
    //       clickToClose: true,
    //       fade: true,
    //       actions: [{
    //         action: "Allow",
    //       }],
    //       icons: {
    //         error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
    //         warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
    //       }
    //     });
    //   })
    // }

    //#region  BUG 3393

    /*
    [web- search result ] the system should not display any result in case  the current date < date +booking grace period
    */

    const StartDate = new Date(this.searchForm.value['PickUpDate']);
    const StartTimeString = this.searchForm.controls["PickUpTime"].value;

    const EndDate = new Date(this.searchForm.value['dropUpDate']);
    const EndTimeString = this.searchForm.controls["dropUpTime"].value;



    if (!this.searchService.validateDropOffVSPickUp(StartDate, StartTimeString, EndDate, EndTimeString)) {
      this.translate.get('DropOffShouldbegreaterthanPickUp').subscribe(res => {
        this._notifications.warn("<span>" + res + "</span>", null, {
          timeOut: 30000,
          showProgressBar: false,
          pauseOnHover: true,
          clickToClose: true,
          fade: true,
          actions: [{
            action: "Allow",
          }],
          icons: {
            error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
            warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
          }
        });
      })
      return;

    }
    //#endregion

    //Validate pickup Time
    /*    if (!this.searchService.validateTime(this.searchForm.value['PickUpTime'], this.minTime)) {
         this.searchForm.controls['PickUpTime']?.setErrors({ 'Invalid': true });
         return;
       } */

    this.searchForm.value['currentLocation'] = this.currentLocation;
    let dropOffLocationObj = this.dropUpLocations.filter(a => a.returnAgencyID == this.selectedLocation)[0];
    this.searchService.updateSelectedDropOffLocation(dropOffLocationObj);

    var _searchModel: VehicleReservationSearchParm = {
      StartDateString: this._dateFormatPipe.transform(this.searchForm.value['PickUpDate']),
      StartDate: this.searchForm.value['PickUpDate'],
      StartTimeString: this.searchForm.controls["PickUpTime"].value,
      EndDateString: this._dateFormatPipe.transform(this.searchForm.value['dropUpDate']),
      EndDate: this.searchForm.value['dropUpDate'],
      EndTimeString: this.searchForm.controls["dropUpTime"].value,
      Latitude: this.currentLocation.lat,
      Longitude: this.currentLocation.lng,
      FormatedLocation:   this.searchModel.FormatedLocation,
      PageSize: this.pageSize,
      PageNumber: this.page,
      DropUpLocationAgencyId: this.selectedLocation,
      ToAgencyID: this.selectedLocation,
      AgencyID: this.searchModel['AgencyID'],
      FromAgencyName: this.searchModel['FromAgencyName'],
    };


    if (this.customer != null) {
      _searchModel.CustomerID = this.customer.customerID;
    }

    if (dropOffLocationObj != null) {
      _searchModel.DropOffLocationTypeID = dropOffLocationObj.agencyReturnLocationTypeID;
    }

    if(this.searchModel.ClassID!=null &&   this.searchModel.MakeID!=null ){
      _searchModel.ClassID=this.searchModel.ClassID;
      _searchModel.MakeID=this.searchModel.MakeID;
      _searchModel.ModelID=this.searchModel.ModelID;
      _searchModel.Year=this.searchModel.Year;
    }
    if (this.searchModel['AgencyID'] == null) {
      this.searchService.updateSearchModel(_searchModel);
      //this.VehicleReservationSearch(_searchModel);
    }
    else {

      //IF same PickUp then stay on the same page
      if (_searchModel.FormatedLocation == this.pickUpLocationName || _searchModel.FormatedLocation == this.searchModel.FromAgencyName) {

      }
      //Else search for branches again
      else {
        _searchModel.AgencyID = null;
        // this.VehicleReservationSearch(_searchModel);
      }
      this.searchService.updateSearchModel(_searchModel);


    }

    //this.searchModel['AgencyID']=null;

  }
  ifStringIsNullOrEmpty(pickUpLocationValue: string): boolean {
    return pickUpLocationValue == null || pickUpLocationValue == '';
  }




  public handleAddressChange(address: Address) {
    // Do some stuff
    //this.address = address;
    this.currentLocation = {
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
    };

  }
  onAutocompleteSelected(result: PlaceResult) {

    this.currentLocation = {
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
    };

    this.address = result;
    this.searchModel.FormatedLocation = result.formatted_address;
  }

  //Event handler when pickup datepicker changed
  addEvent(mode: number, type: string, event: MatDatepickerInputEvent<Date>) {


    //PickUp Date

    if (mode == 1) {
      let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);
      this.minDropOffDate = new Date(event.value);
      if (new Date(event.value).getDate() == new Date().getDate() && new Date(event.value).getDate() == dropOffDate.getDate()) {


        this.searchForm.controls.PickUpTime.setValue(this.minTime);

        this.searchForm.controls.dropUpTime.setValue(this.minDroppOffTime);
      }
      else if (new Date(event.value).getDate() == new Date().getDate()) {

        this.searchForm.controls.PickUpTime.setValue(this.minTime);
      }
      else {
        if (new Date(event.value).getDate() == dropOffDate.getDate()) {

          let pickUpTime = this.searchForm.controls.PickUpTime.value;

          this.searchForm.controls.dropUpTime.setValue(pickUpTime);
        }
        //IF PickUp Date Greter than drop OFF
        else if (new Date(event.value) > dropOffDate) {
          this.searchForm.controls.dropUpDate.setValue(new Date(event.value));
          let pickUpTime = this.searchForm.controls.PickUpTime.value;
          let dropUpTime = this.searchForm.controls.dropUpTime.value;
          if (!this.searchService.validateTime(dropUpTime, pickUpTime)) {

            this.searchForm.controls.dropUpTime.setValue(pickUpTime);
          }
        }
        else {

        }
      }

    }
    //Drop Off Date
    else if (mode == 2) {
      let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
      if (new Date(event.value).getDate() == pickUpDate.getDate()) {
        let pickUpTime = this.searchForm.controls.PickUpTime.value;

        //this.searchForm.controls.dropUpTime.setValue(pickUpTime);
      }
      else {


      }
    }
    this.ngAfterViewInit();



  }

  dropUpLocationChanged(value) {
    this.selectedLocation = value;

  }

  onLocationInputChanged() {
    this.address = null;
    this.currentLocation = null;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }

}

















